export const DASHBOARD_MODE = 'DASHBOARD_MODE'
export const PLAN_BOOK_MODE = 'PLAN_BOOK_MODE'
export const SUB_MODE = 'SUB_MODE'
export const DASHBOARD_MODE_TEXT = 'dashboard'
export const PLAN_BOOK_MODE_TEXT = 'planning_book'
export const DASHBOARD_OPTIONS = {
  CAPACITY: 'Capacity',
  STOCK_BUILD: 'Stock build',
  STOCK_PROJECTION: 'Stock projection',
  VOLUME_PROJECTION: 'Production plan book',
}
